import React from 'react'
import SbEditable from 'storyblok-react'
import Img from 'gatsby-image'
import { getFluidGatsbyImage } from "gatsby-storyblok-image"

const Image = ({ blok, image, params = { maxWidth: 250, quality: 90 }, className, style }) => {

    let fluidProps = getFluidGatsbyImage(image.filename, params)
    
    if (blok) {
        return (
            <SbEditable content={blok}>
                {fluidProps ? (
                    <Img className={className} fluid={fluidProps} style={style} />
                ) : (
                    <img src={image.filename} className={className} alt={image.alt} style={style} />
                )}
            </SbEditable>
        )
    } else {
        return (
            <>
                {fluidProps == null ? (
                    <Img className={className} fluid={fluidProps} style={style} />
                ) : (
                    <img src={image.filename} className={className} alt={image.alt} style={style} />
                )}
            </>
        )
    }
}

export default Image
